import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialogComponent implements OnInit {
  /** Заголовок модального окна. */
  @Input() header: string;
  /** Флаг отображения модального окна. */
  @Input() visible: boolean;
  @Input() styleClass: string;
  @Input() maximizable: boolean = false;
  @Input() minY: number = 70;
  @Input() closable: boolean = true;
  @Input() style: any = {};
  @Output() visibleChange = new EventEmitter<boolean>();
  /** Событие закрытия модального окна. */
  @Output() onHide = new EventEmitter<boolean>();
  /** Событие открытия модального окна. */
  @Output() onShow = new EventEmitter();

  constructor() {}

  /**
   * Обработчик закрытия окна.
   * @param event событие.
   */
  public onClose(event) {
    this.visible = !event;
    this.visibleChange.emit(this.visible);
    this.onHide.emit(event);
  }

  /**
   * Обработчик открытия окна.
   * @param event событие.
   */
  public onOpen(event) {
    this.onShow.emit(event);
  }

  ngOnInit() {}
}
